<template>
  <div>
    <v-btn
      dark small
      color="primary"
      @click="abrirDialog()"
    >
      <v-icon left>mdi-import</v-icon>
      Importar Lista
    </v-btn>

    <SysDialog
      v-model="dialog"
      content-class="bra-20"
      titulo="Importação de lista de preços"
      @click:primary="salvarListaDePreco()"
      @click:hidden-dialog="fecharDialog()"
    >
      <AlertError :errors="errors" />

      <InformativoFormatoArquivo class="mb-2" />

      <SysGrupoAutocomplete
        v-model="form.id_grupo"
        outlined
        label="Selecione o grupo *"
        :error-messages="ERROR_GROUPO"
        @keyup.enter="salvarListaDePreco"
        persistent-placeholder
      />

      <SysFornecedorAutocomplete
        v-model="form.id_fornecedor"
        outlined
        label="Selecione o fornecedor *"
        :error-messages="ERROR_FORNECEDOR"
        @keyup.enter="salvarListaDePreco"
        persistent-placeholder
      />

      <SysDatePicker
        v-model="form.data_validade"
        titulo_label="Data de Validade *"
        outlined
        :data_minima="DATA_ATUAL"
        :error-messages="ERROR_DATA_VALIDADE"
        @keyup.enter="salvarListaDePreco"
        persistent-placeholder
        clearable
      />

      <SysFileInput
        v-model="form.arquivo_importacao"
        titulo_label="CSV de Importação *"
        outlined
        :error-messages="ERROR_ARQUIVO_IMPORTACAO"
        @keydown.enter="salvarListaDePreco"
        persistent-placeholder
      />
    </SysDialog>
  </div>
</template>

<script>
import SysDialog from '@/components/padraoDeLayout/SysDialog.vue';
import SysGrupoAutocomplete from '@/components/utils/crud/SysGrupoAutocomplete.vue';
import SysFornecedorAutocomplete from '@/components/utils/crud/SysFornecedorAutocomplete.vue';
import SysDatePicker from '@/components/utils/SysDatePicker.vue';
import SysFileInput from '@/components/utils/SysFileInput.vue';

import { helpers, required } from "vuelidate/lib/validators";

import { salvarListaDePreco } from "@/api/Fornecedor/ListasDePreco/index.js";
import moment from 'moment';
import InformativoFormatoArquivo from './InformativoFormatoArquivo.vue';
import AlertError from '../../../utils/Alerts/AlertError.vue';

const validarArquivoCSV = helpers.withParams(
  { type: 'csvFile' },
  (item) => {
    if (!item) {
      return true;
    }

    const arquivo = Array.isArray(item) ? item[0] : item instanceof FileList ? item[0] : item;

    const name = arquivo && arquivo.name ? arquivo.name : String(item || '');
    return /\.csv$/i.test(name);
  }
);

export default {
  components: {
    SysDialog,
    SysGrupoAutocomplete,
    SysFornecedorAutocomplete,
    SysDatePicker,
    SysFileInput,
    InformativoFormatoArquivo,
    AlertError
},
  data() {
    return {
      dialog: false,
      selects: {
        grupos: [],
        fornecedores: []
      },
      form: {
        id_grupo: '',
        id_fornecedor: '',
        data_validade: '',
        arquivo_importacao: null
      },
      errors: []
    }
  },
  computed: {
    DATA_ATUAL() {
      return moment().format('YYYY-MM-DD');
    },
    ERROR_GROUPO() {
      const errors = [];
      if (!this.$v.form.id_grupo.$dirty) return errors;
      !this.$v.form.id_grupo.required && errors.push("Campo obrigatório.");
      return errors;
    },
    ERROR_FORNECEDOR() {
      const errors = [];
      if (!this.$v.form.id_fornecedor.$dirty) return errors;
      !this.$v.form.id_fornecedor.required && errors.push("Campo obrigatório.");
      return errors;
    },
    ERROR_DATA_VALIDADE() {
      const errors = [];
      if (!this.$v.form.data_validade.$dirty) return errors;
      !this.$v.form.data_validade.required && errors.push("Campo obrigatório.");
      return errors;
    },
    ERROR_ARQUIVO_IMPORTACAO() {
      const errors = [];
      if (!this.$v.form.arquivo_importacao.$dirty) return errors;
      !this.$v.form.arquivo_importacao.required && errors.push("Campo obrigatório.");
      !this.$v.form.arquivo_importacao.validarArquivoCSV && errors.push("Formato de arquivo não suportado. Selecione um arquivo .csv.");
      return errors;
    },
  },
  methods: {
    abrirDialog() {
      this.dialog = true;
    },
    fecharDialog() {
      this.$v.$reset();

      this.form = {
        id_grupo: '',
        id_fornecedor: '',
        data_validade: '',
        arquivo_importacao: null
      }

      this.errors = [];

      this.dialog = false;
    },
    salvarListaDePreco(e) {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      this.$store.dispatch(
        "loading/addRequisicao",
        salvarListaDePreco(this.form)
          .then((message) => {
            if (message) {
              this.errors = message;
            } else {
              this.form.data_validade = '';
              this.form.arquivo_importacao = null;
              this.fecharDialog();
              this.$emit('atualizar-listas-compra');
            }
          })
      );
    }
  },
  watch: {
    dialog() {
      this.form.data_validade = '';
    }
  },
  validations: {
    form: {
      id_grupo: { required },
      id_fornecedor: { required },
      data_validade: { required },
      arquivo_importacao: { required, validarArquivoCSV }
    }
  }
}
</script>
